export default {
  name: 'KickerWrapper',
  data() {
    return {
      className: 'app__kicker__wrapper',
    };
  },
  computed: {
    jsClass() {
      return 'js__product__kicker';
    },
  },
};
